import { EVENT_BADGE_STYLES } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsBadge/index.constants';
import type { EventsBadgeProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsBadge/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

const SHORT_LABELS: Record<string, string> = { DEVICE: 'DEV' };

/**
 * EventsBadge - Colour-codes an event by channel (SIP / RTP / DEVICE)
 */
export const EventsBadge: React.FC<EventsBadgeProps> = ({ type }) => (
  <span
    className={cn(
      'inline-flex flex-shrink-0 items-center rounded border px-[5px] py-0.5 font-sp-mono text-[9px] font-bold uppercase tracking-[0.06em]',
      EVENT_BADGE_STYLES[type]
    )}
  >
    {SHORT_LABELS[type] ?? type}
  </span>
);
